import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ja from './locales/ja.json';
import zh from './locales/zh.json';

const wechatDetector = {
  name: 'wechat',
  lookup() {
    if (typeof window !== 'undefined' && window.navigator) {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.includes('micromessenger')) {
        return 'zh';
      }
    }
    return undefined;
  },
  cacheUserLanguage() {}
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(wechatDetector);

i18n
  .use(languageDetector) // 加上语言侦测器
  .use(initReactI18next)
  .init({
    resources: {
      ja: { translation: ja },
      zh: { translation: zh },
    },
    fallbackLng: 'ja', // 默认语言
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // optional: 明确指定语言检测顺序和缓存方式
      // 顺序：用户手动选择 > 微信环境判定 > 浏览器默认语言
      order: ['localStorage', 'wechat', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
